import { useCallLog } from "./useCallLog";
import { CallEntry } from "./CallEntry";
import { EmptyState } from "../shared/EmptyState";
import { Phone } from "lucide-react";

interface CallLogProps {
  contactId: string | undefined;
}

export function CallLog({ contactId }: CallLogProps) {
  const { data, isLoading, error } = useCallLog(contactId);

  if (isLoading) {
    return (
      <div style={{ padding: 24, textAlign: "center", color: "#9ca3af" }}>
        Loading calls…
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 24, color: "#dc2626" }}>
        Failed to load calls: {(error as Error).message}
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <EmptyState
        icon={<Phone size={32} />}
        title="No calls yet"
        description="Inbound and outbound calls will appear here."
      />
    );
  }

  return (
    <div style={{ maxHeight: 600, overflowY: "auto" }}>
      {data.map((call) => (
        <CallEntry key={call.id} call={call} />
      ))}
    </div>
  );
}
